import React from "react";

export default function InputForm({ value, setValue, title }) {
  return (
    <div className="relative my-2 w-full flex flex-col items-start justify-center">
      <img
        className="absolute ml-2 opacity-50 w-4 h-4"
        src={
          title === "Email"
            ? "/notebook/iconEmail.svg"
            : title === "Name"
            ? "/notebook/iconAvatar.svg"
            : title === "Linkedin"
            ? "/notebook/iconLinkedin.svg"
            : "/notebook/iconKey.svg"
        }
        alt=""
      />
      <input
        className="w-full rounded-lg pl-8 h-12 border bg-transparent border-gray-light"
        type={title === "Password" ? "password" : "text"}
        placeholder={title}
        name={title.toLowerCase()}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
    </div>
  );
}
